import "@/floor/floor.css";
import { useNavigate } from "react-router-dom";
import { LOGO_FULL } from "@/lib/identity";
import { SurfaceToggle } from "@/components/SurfaceToggle";
import { ServerStatusBar } from "@/components/ServerStatus";
import { tryLeave } from "@/floor/leaveGuard";

// Minimal scan-first shell for the warehouse/floor surface. Deliberately NO sidebar and
// NO complex nav (per blueprint) — the scan screen IS the front door. The toggle is the
// escape hatch back to the full desk experience. Solid white top bar, high contrast.
export function FloorShell({ children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col" data-testid="floor-shell">
      <ServerStatusBar />
      <header className="h-24 bg-white border-b border-[#E2E8F0] sticky top-0 z-40 flex items-center justify-between px-4 sm:px-6">
        {/* Big logo doubles as HOME — tap returns to the Floor quick-hits screen (floor only).
            With a put-away location loaded it asks first (leaveGuard) instead of walking off. */}
        <button type="button" onClick={() => tryLeave(() => navigate("/floor"))} data-testid="floor-home-logo"
          className="flex items-center gap-3 active:scale-95 transition-transform duration-100">
          <img src={LOGO_FULL} className="h-16 w-auto" alt="FAS — Home" data-testid="floor-brand-logo" />
          <span className="hidden sm:block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">Floor</span>
        </button>
        <SurfaceToggle />
      </header>
      <main className="flex-1 flex flex-col min-h-0">{children}</main>
    </div>
  );
}
